module.exports = __webpack_public_path__ + "img/banner.055074e8.png";